import { DoorConfiguration } from '../../configurator/DoorConfiguration';


import blindstockMultiplexService from '../../services/Configurator/BlindstockMultiplexService';
import mountingMaterialService from '../../services/Configurator/MountingMaterialService';
import functionsService from '../../services/Configurator/FunctionsService';

import { Characteristic, ValueDefinition, MapCharacteristicAndValue, BlindstockItem } from '../../configurator/types';
import store from '@/store/index';
import * as formula from '../../configurator/CalculatedCharacteristics/BlindstockMultiplexCharacteristics';

import {getBlindstockLLTValue} from "../../configurator/CalculatedCharacteristics/BlindstockMultiplexCharacteristics";

interface BlindstockMultiplexStore {
    model: any;
    defaultCharacteristicObject: any;
    blindstockMaterialListItems: BlindstockItem[];
    clearedBlindstockByDependency: boolean
}

const initialState: BlindstockMultiplexStore = {
    model: {
        modelUnlocked: false,
        characteristics: [],
        blindstockMaterialCharacteristics: [],
        childCharacteristics: [],
        modelStatus: {
            active: false,
        },
    },
    defaultCharacteristicObject: {
        id: 0,
        description: 'Static Characteristic Description',
        code: 'CHARACTERISTIC_CODE',
        values: [
            {
                id: 0,
                description: 'Static Value Description',
                value: 'No Val',
                resource: '',
            },
        ],
    },
    blindstockMaterialListItems: [],
    clearedBlindstockByDependency: false
};

const getDefaultState = () => {
    return initialState;
};

const state = getDefaultState();

const getters = {
    getStepCharacteristics: (s: any) => s.model.characteristics,
    // This should be used for displaying characteristics and values in components (should replace all getKTU_MM_XYZ)
    getCharacteristicAndValues: (s: any) => {
        return (characteristicCode: string) => getCharacteristic(characteristicCode, s);
    },
    getNrOfValuesByCharacteristic: (s: any) => {
        return (characteristicCode: string) => getNrOfValues(characteristicCode, s);
    },
    checkRadioValue: (s: any) => {
        return (characteristicCode: string, value: string) => checkValue(characteristicCode, value, s);
    },
    getBlindstockMaterialsList: (s: any) => {
        return s.blindstockMaterialListItems;
    },
    getChildCharacteristics: (s: any) => {
        return s.model.childCharacteristics;
    },
    getBlindstockMaterialCharacteristics: (s: any) => {
        return s.model.blindstockMaterialCharacteristics;
    },
    getBlindstockMaterialCharacteristicAndValues: (s: any) => {
        return (characteristicCode: string) => getBlindstockMaterialCharacteristic(characteristicCode, s);
    },
    getClearedBlindstockByDependency: (s: any) => {
        return s.clearedBlindstockByDependency;
    }
};

const actions = {
    // setStepCharacteristics(context: any, payload: any) {
    //     context.commit('updateStepCharacteristics', payload);
    // },
    addCharacterisitc(context: any, { characteristic, valueDefinition }: any) {
        const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
        const configuration = context.rootState.configuratorModule.doorConfiguration;
        configuration.Add(DoorConfiguration.BlindstockMultiplex, selectedCharacteristic);
    },
    valueAddCharacteristic(context: any, { characteristicValue, value }: any) {
        characteristicValue.values[0].value = value;
        const selectedCharacteristic = MapCharacteristicAndValue(characteristicValue, characteristicValue.values[0]);
        context.rootState.configuratorModule.doorConfiguration.AddNumericCharacteristic(DoorConfiguration.BlindstockMultiplex, selectedCharacteristic);
    },
    checkBoxAddCharacteristic(context: any, { characteristicCode, value }: any) {
        const characteristic = getCharacteristic(characteristicCode, context.state);
        let valueDefinition = characteristic.values.filter((e: any) => e.value === value)[0];
        const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
        context.rootState.configuratorModule.doorConfiguration.Add(DoorConfiguration.BlindstockMultiplex, selectedCharacteristic);
    },

    calculateBlindstockCharacteristic(context: any) {
        const blindstockCharacteristicValue = getBlindstockLLTValue();
        if (typeof blindstockCharacteristicValue !== 'undefined') {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.Frame, 'KTU_MM_BLINDSTOCK', blindstockCharacteristicValue);
        }
    },

    async setCharacteristicsFromDB(context: any) {
        blindstockMultiplexService.getBlindstockMultiplexCharacteristics().then((response: any) => {

            context.commit('updateStepCharacteristics', response.data);
            context.commit('updateSingleCharacteristicsFilteredOrDefaults', context.rootState.configuratorModule.doorConfiguration);
        });
    },


    async setBlindstockMaterialCharacteristics(context: any, nprogress: any) {
        return mountingMaterialService.getMountingMaterialCharacteristics().then((response: any) => {
            context.commit('updateBlindstockMaterialCharacteristics', response.data);
        });
    },
    setChildCharacteristics(context: any) {
        // const mountingMaterialParentChars: string[] = ['KTU_MM_ABDECKLEISTE', 'KTU_MM_WINKEL', 'KTU_MM_BLINDSTOCK_MM', 'KTU_MM_MDF'];
        const mountingMaterialParentChars: string[] = ['KTU_MM_BLINDSTOCK_MM'];

        mountingMaterialService.getChildCharacteristicsByParentCharacteristicCodes(mountingMaterialParentChars).then((response: any) => {
            context.commit('updateChildCharacteristics', response.data);
        });
    },
    setCharacteristicDependencies(context: any, { anchorCharacteristic, dependencieCharacteristic }: any) {
        const anchor: Characteristic = anchorCharacteristic;

        const filteredDependencies = `${dependencieCharacteristic.id}-${dependencieCharacteristic.value.id}`;

        const characteristic = functionsService.extractDependencies(anchor.id, filteredDependencies)
        .then((response: any) => {
            context.commit('updateCharacteristicDependencies', response.data);
        });
    },
    addBlindstockMaterial(context: any, payload: any) {
        context.commit('updateMountingMaterialList', payload);
    },
    clearBlindstockMaterialList(context: any) {
        context.commit('clearBlindstockMaterialList');
    },
    initBlindStockMultiplexModule(context : any, payload : any){
        context.commit('initBlindStockMultiplexModule', payload);
    },
    updateBlindstockMultiplexFormula(context : any) {
        let doorConfiguration = context.rootState.configuratorModule.doorConfiguration;
        context.commit('updateBlindstockMultiplexFormula', doorConfiguration);
    },

    clearBlindstockMultiplexFormula(context : any) {
        let doorConfiguration = context.rootState.configuratorModule.doorConfiguration;
        context.commit('clearBlindstockMultiplexFormula', doorConfiguration);
    },

    clearBlinstockMaterialList(context: any, payload : any) {
        let sapValues = context.rootState.mountingMaterialModule.mountingMaterialListItemsForSap;
        context.commit('clearBlinstockMaterialList', {payload: payload, sapValues: sapValues});
    },


    resetState(context : any)
    {
        context.commit('resetState');
    },
    updateClearedBlindstockByDependency(context: any, payload: boolean) {
        context.commit('updateClearedBlindstockByDependency', payload);
    }
};

const mutations = {
    resetState(s: any) {
        console.log("blindStockModule  reset state");
        Object.assign(s, getDefaultState());
        s.blindstockMaterialListItems = [];
    },
    updateStepCharacteristics(s: any, payload: any) {
        s.model.characteristics = payload.characteristics;
    },
    updateSingleCharacteristicsFilteredOrDefaults(s: any, doorConfiguration: any) {
        addSingleCharacteristicsFilteredOrDefaults(s);
        setBlindstockMultiplexFormula(doorConfiguration);
    },

    updateBlindstockMultiplexFormula(s: any, doorConfiguration: any) {
        setBlindstockMultiplexFormula(doorConfiguration);
    },

    clearBlindstockMultiplexFormula(s: any, doorConfiguration: any) {
        emptyBlindstockMultiplexFormula(doorConfiguration)
    },

    updateChildCharacteristics(s: any, payload: any) {
        s.model.childCharacteristics = payload.characteristics;
    },
    updateBlindstockMaterialCharacteristics(s: any, payload: any) {
        s.model.blindstockMaterialCharacteristics = payload.characteristics;
    },
    updateMountingMaterialList(s: any, payload: any) {
        s.blindstockMaterialListItems.push(payload);
    },
    updateCharacteristicDependencies(s: any, payload: any) {
        const characteristic = payload.characteristics[0];
        // console.log(characteristic.code);
        if (typeof characteristic !== 'undefined') {
            addOrReplaceBlindstockMaterialCharacteristic(characteristic, s);

            // Dont need to add sigle characteristics. This step deiffers from other steps.
            // addSingleCharacteristicsFilteredOrDefaults(s);
        }
    },
    clearBlinstockMaterialList(s: any, payload : any) {
        console.log(payload)
        let index = s.blindstockMaterialListItems
            .map((x:any) => { return x.id; }).indexOf(payload.payload.id);
        s.blindstockMaterialListItems.splice(index, 1);
        for(let i = 0 ; i< payload.sapValues.length; i++) {
            if (payload.payload.grosse.code === 'KTU_MM_BLINDSTOCK_MM') {
                if(payload.sapValues[i].find((x:any) => x.code === payload.payload.anzahl.code).value === payload.payload.anzahl.value.value &&
                    payload.sapValues[i].find((x:any) => x.code === payload.payload.breite.code).value === payload.payload.breite.value.value &&
                    payload.sapValues[i].find((x:any) => x.code === payload.payload.grosse.code).value === payload.payload.grosse.value.value &&
                    payload.sapValues[i].find((x:any) => x.code === payload.payload.laenge.code).value === payload.payload.laenge.value.value &&
                    payload.sapValues[i].find((x:any) => x.code === payload.payload.hoehe.code).value === payload.payload.hoehe.value.value
                ) {
                    payload.sapValues[i].find((x:any) => x.code === payload.payload.anzahl.code).value = '';
                    payload.sapValues[i].find((x:any) => x.code === payload.payload.breite.code).value ='';
                    payload.sapValues[i].find((x:any) => x.code === payload.payload.grosse.code).value ='';
                    payload.sapValues[i].find((x:any) => x.code === payload.payload.laenge.code).value ='';
                    payload.sapValues[i].find((x:any) => x.code === payload.payload.hoehe.code).value ='';
                }
            }

            let obj = [];
            for(let j = 0; j < payload.sapValues[i].length; j++) {
                obj.push(payload.sapValues[i][j].value);
            }
            let shouldRemoveObject = !obj.some((val) => val !== '');
            if(shouldRemoveObject) {
                payload.sapValues.splice(i, 1);
            }
        }

    },
    initBlindStockMultiplexModule(state : any, payload : any) {
        state.model.childCharacteristics = payload.model.childCharacteristics;
        state.model.blindstockMaterialCharacteristics = payload.model.blindstockMaterialCharacteristics;
        state.blindstockMaterialListItems = payload.blindstockMaterialListItems;
    },
    updateClearedBlindstockByDependency(s: any) {
        const result = formula.calculateALLESBLINDSTOCK();
        let disableBlindstockWerth = false;
        if (result.blindstock_S_Anz === 0)
            disableBlindstockWerth = true;
        
        s.clearedBlindstockByDependency = disableBlindstockWerth;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

const setBlindstockMultiplexFormula = (doorConfiguration: any) => {
    const result = formula.calculateALLESBLINDSTOCK();
    const wertheimBlindstock = store.getters['configuratorModule/getRegisteredCharacteristicsValue']('CUST_MM_BLINDSTOCK_WERTH',DoorConfiguration.BlindstockMultiplex).value.value;
    if (wertheimBlindstock === 'JA') {
        doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'CUST_MM_BLINDSTOCK_S_ANZ', result.blindstock_S_Anz);
        doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_S_BREITE', result.blindstock_S_Breite);
        doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_S_HOEHE', result.blindstock_S_Hoehe);
        doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_S_LAENGE', result.blindstock_S_Laenge);

        doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'CUST_MM_BLINDSTOCK_W_ANZ', result.blindstock_W_Anz);
        doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_W_BREITE', result.blindstock_W_Breite);
        doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_W_HOEHE', result.blindstock_W_Hoehe);
        doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_W_LAENGE', result.blindstock_W_Laenge);
        // doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_MM', 'LLT800065');
    }
};

const emptyBlindstockMultiplexFormula = (doorConfiguration: any) => {
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'CUST_MM_BLINDSTOCK_S_ANZ', '');
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_S_BREITE', '');
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_S_HOEHE', '');
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_S_LAENGE', '');

    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'CUST_MM_BLINDSTOCK_W_ANZ', '');
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_W_BREITE', '');
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_W_HOEHE', '');
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_W_LAENGE', '');
    // doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.BlindstockMultiplex, 'KTU_MM_BLINDSTOCK_MM', '');
};

// Helper Methods
const addSingleCharacteristicsFilteredOrDefaults = (s: any) => {
    const frameCharacteristics = s.model.characteristics;
    frameCharacteristics.forEach((char: any) => {
        if (char.values.length === 1) {
            const selectedCharacteristic = MapCharacteristicAndValue(char, char.values[0]);
            const currentDoorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
            currentDoorConfiguration.Add(DoorConfiguration.BlindstockMultiplex, selectedCharacteristic);
        } else {
            var geter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
            const regChar = geter(char.code, DoorConfiguration.BlindstockMultiplex);
            const exists = regChar.id === char.id;
            const registeredValue = char.values.filter((x: any) => x.id === regChar.value.id)[0];
            const incorrectValue = typeof registeredValue === 'undefined' ? true : false;
            if (exists === false || incorrectValue === true) {
                const valueItem = char.values[0];
                const selectedCharacteristic2 = MapCharacteristicAndValue(char, valueItem);
                const currentDoorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
                currentDoorConfiguration.Add(DoorConfiguration.BlindstockMultiplex, selectedCharacteristic2);
            }
        }
    });
};

// used for managing dependencies
const addOrReplaceCharacteristic = (returnedCharacteristic: any, s: any) => {
    const characteristic = returnedCharacteristic;
    const modelCharacteristics = s.model.characteristics;

    let filteredCharacteristic: any;
    filteredCharacteristic = modelCharacteristics.filter((item: any) => item.code === characteristic.code);
    if (filteredCharacteristic.length !== 0) {
        if (filteredCharacteristic[0].id === characteristic.id) {
            const characteristicIndex: number = modelCharacteristics.indexOf(filteredCharacteristic[0]);
            modelCharacteristics.splice(characteristicIndex, 1, characteristic);
        }
    } else {
        modelCharacteristics.push(characteristic);
    }
};

const getCharacteristic = (code: string, s: any) => {
    const filteredCharacteristic = s.model.characteristics.filter((characteristic: any) => characteristic.code === code)[0];

    if (typeof filteredCharacteristic !== 'undefined') {
        return filteredCharacteristic;
    } else {
        return s.defaultCharacteristicObject;
    }
};

const getBlindstockMaterialCharacteristic = (code: string, s: any) => {
    const filteredCharacteristic = s.model.blindstockMaterialCharacteristics.filter((characteristic: any) => characteristic.code === code)[0];

    if (typeof filteredCharacteristic !== 'undefined') {
        return filteredCharacteristic;
    } else {
        return s.defaultCharacteristicObject;
    }
};

const getNrOfValues = (code: string, s: any) => {
    const filteredCharacteristic = s.model.characteristics.filter((characteristic: any) => characteristic.code === code)[0];
    if (typeof filteredCharacteristic !== 'undefined') {

        return filteredCharacteristic.values.length;
    } else {
        return 0;
    }
};

const checkValue = (characteristicCode: string, value: string, s: any) => {
    const definedValues = store.state.configuratorModule.doorConfiguration.Get(DoorConfiguration.BlindstockMultiplex);
    const filteredCharacteristic: any = definedValues.filter((item: any) => item.code === characteristicCode && item.value.value === value)[0];

    if (filteredCharacteristic != null || typeof filteredCharacteristic !== 'undefined') {
        return true;
    }
    return false;
};

// used for checkboxes
const getAppropValue = (characteristicCode: string, context: any) => {
    const characteristic = getCharacteristic(characteristicCode, context.state);
    var geter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
    const registeredCharacteristic = geter(characteristicCode, DoorConfiguration.BlindstockMultiplex);
    let valueDefinition;

    if (characteristic.values.length > 1) {
        valueDefinition = characteristic.values.filter((x: any) => x.id !== registeredCharacteristic.value.id)[0];
    } else {
        valueDefinition = characteristic.values[0];
    }

    const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
    return selectedCharacteristic;
};

const addOrReplaceBlindstockMaterialCharacteristic = (returnedCharacteristic: any, s: any) => {
    const characteristic = returnedCharacteristic;
    const modelCharacteristics = s.model.blindstockMaterialCharacteristics;

    let filteredCharacteristic: any;
    filteredCharacteristic = modelCharacteristics.filter((item: any) => item.code === characteristic.code);
    if (filteredCharacteristic.length !== 0) {
        if (filteredCharacteristic[0].id === characteristic.id) {
            const characteristicIndex: number = modelCharacteristics.indexOf(filteredCharacteristic[0]);
            modelCharacteristics.splice(characteristicIndex, 1, characteristic);
        }
    } else {
        modelCharacteristics.push(characteristic);
    }
};
